<app-page-modifications>
<app-header class="full-width"></app-header>
  <main id="content" class="js-content" role="main">
    <div class="grid-row">
      <div class="column-full">
        <div class="submission-description">
          <h2 tabindex="0" class="aa-title-size">{{title}}</h2>
          <br>
          <app-svg-girl aria-hidden="true"></app-svg-girl>
          <app-svg-loading aria-hidden="true"></app-svg-loading>
          <span class="wait-text aa-lead-size" tabindex="0">
            Please wait, do not close or shut down
          </span>
        </div>
      </div>
    </div>
  </main>
</app-page-modifications>
